define('../src/journeys/j4-contact-us/j4-contact-us',['jquery', 'lib/utils'], function($, utils) {

    'use strict';

    var J4_CONTACT = function($journey) {

        this.$journey = $journey;

        return this;
    };

    J4_CONTACT.prototype.init = function() {
        var _this = this;

        _this.resizeHeight()

        //this.$journey.css('min-height', );
        
    };
    J4_CONTACT.prototype.resizeHeight = function(){
        var _this = this;
        this.$journey.css('min-height', Math.max(this.$journey.find('.j4-contact-us--innerbar').outerHeight(true) + 250, ($(window).outerHeight(true) - $('header').outerHeight(true) - $('footer').outerHeight(true))));
    }

    return J4_CONTACT;
});

